/*
  Carrusel de la landing Lejan One FW26.

  El diseno no dibuja flechas ni puntos: las fotos se desbordan a proposito y se navegan
  arrastrando (raton) o deslizando (tactil). El deslizamiento tactil y el scroll con
  trackpad los da el navegador solo via `overflow-x: auto`; este script anade unicamente
  el arrastre con raton, que en desktop no existe de serie.

  El snap se desactiva mientras se arrastra: si se deja activo, el navegador pelea contra
  el puntero e imanta el slide a mitad de gesto.
*/
(function () {
  'use strict';

  var DRAG_THRESHOLD = 4; // px antes de considerar que es un arrastre y no un clic

  function initCarousel(track) {
    if (track.dataset.lofCarouselReady === 'true') return;
    track.dataset.lofCarouselReady = 'true';

    var isDown = false;
    var didDrag = false;
    var startX = 0;
    var startScroll = 0;

    function onPointerDown(e) {
      if (e.pointerType === 'touch') return; // el tactil ya lo maneja el navegador
      isDown = true;
      didDrag = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.style.scrollSnapType = 'none';
      track.classList.add('is-grabbing');
    }

    function onPointerMove(e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (!didDrag && Math.abs(dx) < DRAG_THRESHOLD) return;
      didDrag = true;
      track.setPointerCapture(e.pointerId);
      track.scrollLeft = startScroll - dx;
      e.preventDefault();
    }

    function onPointerUp() {
      if (!isDown) return;
      isDown = false;
      track.style.scrollSnapType = '';
      track.classList.remove('is-grabbing');
    }

    // Si el gesto acabo siendo un arrastre, el clic que el navegador dispara despues
    // no debe activar el enlace que hubiera debajo.
    function onClickCapture(e) {
      if (didDrag) {
        e.preventDefault();
        e.stopPropagation();
        didDrag = false;
      }
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', onPointerUp);
    track.addEventListener('pointercancel', onPointerUp);
    track.addEventListener('pointerleave', onPointerUp);
    track.addEventListener('click', onClickCapture, true);

    // Evita el arrastre nativo de imagenes, que secuestra el gesto
    track.querySelectorAll('img').forEach(function (img) {
      img.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-lof-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // El editor de temas recarga secciones sueltas sin recargar la pagina
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
